export default __webpack_public_path__ + "static/booking-1-92f759a41d4d16c42f9ac6f9faef47b8.jpg";